export default __webpack_public_path__ + "static/media/app2-21.070373ab.jpg";